import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Scissors, Tag, MapPin, MessageCircle } from "lucide-react";
import "./Landing.css";

const benefits = [
  ["Çalışmalarını göster", "Saç kesimlerini bir araya getir. Müşterin farklı stillere baksın, istediği modeli bulsun."],
  ["Fiyatlarını paylaş", "Saç kesimi, sakal ve diğer hizmetlerinin fiyatları tek yerde, açıkça görülsün."],
  ["Konumunu ve yorumlarını göster", "Müşterin yorumları okusun, çalışma saatlerini görsün ve yol tarifini açsın."],
  ["Sohbet WhatsApp’ta devam etsin", "Müşterin beğendiği kesim için doğrudan sana yazsın. Sorularını alıştığın yerden yanıtla."],
];

export default function Landing() {
  const [mobilePreview, setMobilePreview] = React.useState(() => window.matchMedia("(max-width: 767px)").matches);

  React.useEffect(() => {
    const media = window.matchMedia("(max-width: 767px)");
    const updatePreview = () => setMobilePreview(media.matches);
    updatePreview();
    media.addEventListener("change", updatePreview);
    return () => media.removeEventListener("change", updatePreview);
  }, []);

  return (
    <div className="theme-public landing-page">
      <header className="landing-header landing-container">
        <Link to="/" className="landing-wordmark" data-testid="brand-mark" aria-label="TarzBerber ana sayfa">TarzBerber</Link>
        <Link to="/login" className="landing-login" data-testid="nav-login">Berber girişi <ArrowUpRight size={15} aria-hidden="true" /></Link>
      </header>
      <main>
        <section className="landing-hero landing-container" aria-labelledby="landing-heading">
          <div className="landing-intro">
            <h1 id="landing-heading">İşini göster.<br />Müşterin seni tanısın.</h1>
            <p className="landing-lead">TarzBerber, berberler için dijital bir vitrin. Saç kesimlerin, fiyatların, yorumların ve iletişim bilgilerin tek bir profilde.</p>
            <p className="landing-explainer">Müşterin modellere baksın, beğendiği kesim için WhatsApp’tan sana yazsın.</p>
            <Link to="/ornek" className="landing-button" data-testid="cta-view-demo">Örnek profili gör <ArrowUpRight size={18} aria-hidden="true" /></Link>
            <p className="landing-share-note">Profil linkini Instagram’da, Google’da veya dükkânındaki QR kodla paylaş.</p>
          </div>
          <figure className="landing-preview">
            <div className="landing-preview-frame">
              <div className="landing-preview-address">tarzberber / ornek</div>
              <iframe
                src="/ornek"
                title="TarzBerber örnek berber profili"
                className="landing-preview-screen"
                inert={mobilePreview}
                tabIndex={mobilePreview ? -1 : 0}
                aria-hidden={mobilePreview ? true : undefined}
                scrolling={mobilePreview ? "no" : "auto"}
              />
            </div>
            <figcaption>
              <span>Müşterinin göreceği profil.<br />{mobilePreview ? "İncelemek için tam sayfa aç." : "İçinde kaydırıp inceleyebilirsin."}</span>
              <Link to="/ornek" data-testid="nav-demo">Tam sayfa aç <ArrowUpRight size={14} aria-hidden="true" /></Link>
            </figcaption>
          </figure>
        </section>
        <section className="landing-benefits landing-container" aria-labelledby="landing-benefits-heading">
          <div className="landing-section-intro">
            <h2 id="landing-benefits-heading">Dükkânına gelmeden<br />seni tanısınlar.</h2>
            <p>Yaptığın iş ve müşterinin bilmek istedikleri. Hepsi aynı linkte.</p>
          </div>
          <div className="landing-benefit-list">
            {benefits.map(([title, description], index) => {
              const Icon = [Scissors, Tag, MapPin, MessageCircle][index];
              return <article key={title}><h3><Icon className="landing-benefit-icon" size={16} strokeWidth={1.5} aria-hidden="true" />{title}</h3><p>{description}</p></article>;
            })}
          </div>
        </section>
        <section className="landing-final landing-container" aria-labelledby="landing-final-heading">
          <div>
            <h2 id="landing-final-heading">Bir müşteri gibi göz at.</h2>
            <p>Kesimleri, fiyatları ve profilin nasıl çalıştığını örnek sayfada gör.</p>
          </div>
          <Link to="/ornek" className="landing-button">Örnek profili gör <ArrowUpRight size={18} aria-hidden="true" /></Link>
        </section>
      </main>
      <footer className="landing-footer landing-container">
        <span>TarzBerber</span>
        <Link to="/login" data-testid="cta-login">Berber girişi</Link>
      </footer>
    </div>
  );
}
